/* ===================================================================
   Product Showcase — Infinite Slider
   Progressive enhancement for the "Add to cart" buttons.

   Without JS the forms submit normally to /cart/add (full page → cart).
   With JS we intercept, POST to /cart/add.js, give inline feedback, and
   notify the theme so the cart drawer / bubble can refresh.
   =================================================================== */
(function () {
  'use strict';

  function refreshCartUI() {
    // Ask the theme to re-fetch cart sections if it supports the standard
    // Shopify cart-sections API; otherwise dispatch a generic event themes
    // commonly listen for. Both are best-effort and safely ignored.
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:build'));

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
        );
      })
      .catch(function () {});
  }

  function flash(button, text, modifier) {
    var label = button.querySelector('.pss__atc-label') || button;
    var original = button.getAttribute('data-original-label');
    if (original === null) {
      original = label.textContent;
      button.setAttribute('data-original-label', original);
    }
    label.textContent = text;
    button.classList.add(modifier);
    window.setTimeout(function () {
      label.textContent = original;
      button.classList.remove(modifier);
      button.disabled = false;
    }, 1800);
  }

  function handleSubmit(event) {
    var form = event.target.closest('[data-pss-cart]');
    if (!form) return;

    event.preventDefault();

    var button = form.querySelector('.pss__atc');
    if (button.disabled) return;
    button.disabled = true;
    button.classList.add('is-loading');

    fetch(
      window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: 1
        })
      }
    )
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function () {
        button.classList.remove('is-loading');
        flash(button, 'Added ✓', 'is-added');
        refreshCartUI();
      })
      .catch(function () {
        button.classList.remove('is-loading');
        flash(button, 'Try again', 'is-error');
      });
  }

  document.addEventListener('submit', handleSubmit);
})();
